import { useQuery } from '@tanstack/react-query'
import { fetchTrustScore } from './trustApi'
import type { TrustScoreData } from './types'

export function useTrustScore(vendorUserId: number | null | undefined) {
  return useQuery({
    queryKey:  ['trust-score', vendorUserId],
    queryFn:   () => fetchTrustScore(vendorUserId as number),
    enabled:   vendorUserId != null && vendorUserId > 0,
    staleTime: 10_000,
  })
}

export type { TrustScoreData }
